import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AuthentificationService } from "src/app/services/auth/authentification.service";
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class SignedOutGuard implements CanActivate {

    constructor(private router: Router , private authentificationService: AuthentificationService, private location: Location) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authentificationService.isSignedIn()) {
            return false;
        }
        if (this.authentificationService.isManagedAccess()) {
            const managedAccess = this.authentificationService.getManagedAccess();
            this.authentificationService.clearManagedAccess();
            window.location.href = managedAccess;
            return false;
        }
        return true;
    }

}
